import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { authApi } from '../api/api';
import LoadingSpinner from '../components/LoadingSpinner';
import './Auth.css';

const VerifyEmail: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const verifyEmail = async (): Promise<void> => {
      try {
        await authApi.verifyEmail(token || '');
        setSuccess(true);
      } catch (err) {
        const error = err as { response?: { data?: { message?: string } } };
        setError(error.response?.data?.message || 'Invalid or expired verification link');
      }
      setLoading(false);
    };

    verifyEmail();
  }, [token]);

  if (loading) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-header">
            <h1>Verifying Email</h1>
            <p>Please wait...</p>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
            <LoadingSpinner size="large" />
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-header">
            <h1>Email Verified!</h1>
            <p>Your email has been successfully verified.</p>
          </div>
          <div className="auth-success-message">
            <p>You can now submit uniform order requests through the portal.</p>
          </div>
          <div className="auth-footer">
            <Link to="/login" className="btn btn-primary btn-block">
              Go to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Verification Failed</h1>
          <p>{error}</p>
        </div>
        <div className="auth-success-message">
          <p>The verification link may have expired or already been used.</p>
          <p>Please try logging in, or contact us at (830) 896-0114 for assistance.</p>
        </div>
        <div className="auth-footer">
          <Link to="/login" className="btn btn-primary btn-block">
            Go to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
